import moment from 'moment';
const formatDate = (date) => {
    const itemDate = new Date(date * 1000);
    const itemYear = itemDate.getFullYear();
    const itemMonth = itemDate.getMonth() + 1;
    const itemDay = itemDate.getDate();
    const curDate = new Date();
    // 不在今年返回完整日期 y-m-d
    if (curDate.getFullYear() !== itemYear) {
        return `${itemYear}-${itemMonth}-${itemDay}`;
    } if (itemDay === curDate.getDate() && itemMonth === curDate.getMonth() + 1) {
        return '今天';
    } if (itemDay + 1 === curDate.getDate() && itemMonth === curDate.getMonth() + 1) {
        return '昨天';
    }
    // 今年返回 m-d
        return `${itemMonth}-${itemDay}`;
};
const toDate = (date) => {
    const itemDate = new Date(date * 1000);
    const itemYear = itemDate.getFullYear();
    const itemMonth = itemDate.getMonth() + 1;
    const itemDay = itemDate.getDate();
    if (!date) return '-';
    return `${itemYear}-${itemMonth < 10 ? `0${itemMonth}` : itemMonth}-${itemDay < 10 ? `0${itemDay}` : itemDay}`;
};
const toTimeString = (value, formatter = 'YYYY-MM-DD HH:mm:ss') => {
    return value !== null && +value >= 0 ? moment.unix(value).format(formatter) : '-';
};
export {
    formatDate,
    toDate,
    toTimeString,
};
